import { render } from "./adminNetwork.vue?vue&type=template&id=00d4c033"
import script from "./adminNetwork.vue?vue&type=script&lang=js"
export * from "./adminNetwork.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__